import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-img-top position-relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "small" }
const _hoisted_5 = { class: "small d-none" }
const _hoisted_6 = { class: "card-title h6 small mb-0 align-self-end d-flex flex-column w-100 position-relative" }
const _hoisted_7 = {
  key: 0,
  class: "flex-fill"
}
const _hoisted_8 = { class: "position-absolute small top-0 end-0 mt-1 me-2 d-flex" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "form-check form-switch ms-2 my-0 px-0" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-column py-0 px-0 justify-content-around"
}
const _hoisted_13 = { class: "class-card-name" }
const _hoisted_14 = {
  key: 1,
  class: "py-1 px-2 class-done-text"
}
const _hoisted_15 = {
  key: 2,
  class: "py-1 px-2 class-done-text"
}
const _hoisted_16 = {
  key: 3,
  class: "py-1 px-2 class-done-text"
}
const _hoisted_17 = {
  key: 4,
  class: "py-1 px-2 class-done-text",
  title: "Solicita el acceso a tu líder"
}
const _hoisted_18 = {
  key: 5,
  class: "py-1 px-2 class-done-text"
}
const _hoisted_19 = {
  key: 1,
  class: "action-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_ctx.classDate && _ctx.classData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["card class-card mb-2", {
      'class-card-editable': _ctx.editPermission,
      disabled: _ctx.classStatus == 'inactive',
      'current-class': _ctx.classStatus == 'current',
      'locked-class': _ctx.classStatus == 'locked',
    }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.getImage(),
            alt: "",
            class: "card-img-top"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", {
            class: _normalizeClass(["card-img-overlay p-2 text-start d-flex text-white", {
          'card-img-overlay-gradient': _ctx.classData.showTitle,
        }])
          }, [
            (_ctx.classData.requiredRank)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "badge bg-success rounded-pill position-absolute top-10 end-0 translate-middle-y",
                  title: 'Exclusivo ' + _ctx.rankName(_ctx.classData.requiredRank)
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_rank_icon, {
                      "icon-class": _ctx.rankIconClass(_ctx.classData.requiredRank),
                      "extra-class": "fas text-light fa-fw fa-lg my-1"
                    }, null, 8, ["icon-class"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.rankName(_ctx.classData.requiredRank)), 1)
                  ])
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.classData.showTitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.classData.title), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.editPermission)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        class: "form-check-input border border-white ms-0",
                        type: "checkbox",
                        role: "switch",
                        checked: _ctx.classStatus != 'inactive',
                        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeStatus && _ctx.changeStatus(...args)))
                      }, null, 40, _hoisted_11)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["card-body p-2 mb-0 small text-nowrap", _ctx.btnClass])
        }, [
          (_ctx.editPermission)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-circle fa-xs fa-fw", [_ctx.isLiteAllowed ? 'pkg-text-gtr-go' : 'text-light-gray']]),
                  title: "GTR Go"
                }, null, 2),
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-circle fa-xs fa-fw", [
            _ctx.isBasicOrVipAllowed ? 'pkg-text-gtr-fly' : 'text-light-gray',
          ]]),
                  title: "GTR Fly/Win"
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createElementVNode("span", {
            class: "hidden-text py-1 px-2",
            "aria-hidden": "true"
          }, "Hidden text", -1)),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.classStatus == 'current' && !_ctx.editPermission)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-outline-primary btn-sm",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openClass(_ctx.classData.link)))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fas fa-external-link-alt me-1" }, null, -1),
                  _createElementVNode("span", null, "Unirse", -1)
                ]))]))
              : (_ctx.classStatus == 'current' && _ctx.editPermission)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "fas fa-check-square me-1" }, null, -1),
                    _createTextVNode("Actual ", -1)
                  ]))]))
                : (_ctx.classStatus == 'done')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "fas fa-check-square me-1" }, null, -1),
                      _createTextVNode("Terminada ", -1)
                    ]))]))
                  : (_ctx.classStatus == 'future')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "far fa-clock me-1" }, null, -1),
                        _createTextVNode("Programada ", -1)
                      ]))]))
                    : (_ctx.classStatus == 'locked')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "fas fa-lock me-1" }, null, -1),
                          _createTextVNode(" Bloqueada ", -1)
                        ]))]))
                      : (_ctx.classStatus == 'inactive')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fas fa-eye-slash me-1" }, null, -1),
                            _createTextVNode(" Inactiva ", -1)
                          ]))]))
                        : _createCommentVNode("", true)
          ]),
          (_ctx.editPermission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "btn btn-danger text-light btn-sm",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmRemove()))
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fas fa-trash mr-0" }, null, -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editClass()))
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "fas fa-pencil-alt mr-0" }, null, -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}